export class CreateCredentialsProfileInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCredentialsProfileInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
